import { Text } from '@components/_rcpo/ui/Text'
import { cn } from '@lib/cn'
import { useRouter } from 'next/router'
import { FC } from 'react'

export const ResetFilters: FC = () => {
  const { query, push } = useRouter()

  return (
    <button
      className={cn(
        'rounded-full border border-solid border-rolexPrimary bg-white text-rolexPrimary transition-colors duration-150',
        'hover:bg-rolexPrimary hover:text-white',
        'disabled:cursor-not-allowed disabled:border-rolexShade-200 disabled:bg-rolexShade-200 disabled:text-rolexShade-700',
        'ml-4 flex h-10 w-10 items-center justify-center',
        'lg:ml-0 lg:h-auto lg:w-auto lg:px-5 lg:py-3',
      )}
      disabled={!Object.keys(query).length}
      onClick={() => resetFilterParams()}
    >
      <svg height="15" width="15" viewBox="0 0 15 15" fill="currentColor" className="lg:mr-6">
        <path d="m15 7.5c0 3.9-3.1 7-7 7-2 0-3.8-.9-5.1-2.2l1.2-1.6c.9 1.1 2.3 1.8 3.9 1.8 2.8 0 5-2.2 5-5s-2.2-5-5-5c-2.6 0-4.7 2-4.9 4.5h.9l-1 1-1 1-1-1-1-1h1c0-.2 0-.4.1-.7 0-.2.1-.4.1-.6 0 0 0 0 0-.1 0-.2.1-.4.2-.5v-.1c.1-.2.1-.3.2-.5 0-.1 0-.1.1-.1.1-.2.2-.3.3-.4 0-.1 0-.2.1-.2.1-.1.2-.2.2-.3.1-.1.1-.1.2-.2 0-.2.1-.3.2-.4s.1-.2.2-.2c.1-.1.2-.2.2-.2.1-.1.2-.2.3-.2.1-.1.1-.2.2-.3.1 0 .2-.1.3-.2.1 0 .2-.1.3-.1.1-.1.2-.1.4-.2.1 0 .1-.1.2-.1 0-.1.2-.2.3-.3.1 0 .1-.1.2-.1.2 0 .3-.1.4-.1s.1-.1.2-.1.3-.1.4-.1.1 0 .2-.1c.2 0 .3-.1.5-.1h.2.7c4 0 7.1 3.1 7.1 7z" />
      </svg>
      <Text variant="regular" className="hidden leading-[1] text-inherit lg:block">
        Reset filter
      </Text>
    </button>
  )

  function resetFilterParams() {
    push(
      {
        query: {},
      },
      undefined,
      {
        shallow: true,
      },
    )
  }
}
